import { useEffect } from 'react';

/** 열려 있는 동안 뒤 페이지 스크롤 막기 — 모달·패널이 겹쳐도 마지막이 닫힐 때 한 번만 풀고, 스크롤바 자리만큼 밀리지 않게 채운다 */

let locks = 0;
let saved = null;

const useScrollLock = (active) => {
  useEffect(() => {
    if (!active) return undefined;
    if (locks === 0) {
      const { body } = document;
      const gap = window.innerWidth - document.documentElement.clientWidth;
      saved = { overflow: body.style.overflow, paddingRight: body.style.paddingRight };
      body.style.overflow = 'hidden';
      if (gap > 0) body.style.paddingRight = `${gap}px`;
    }
    locks += 1;
    return () => {
      locks -= 1;
      if (locks === 0 && saved) {
        document.body.style.overflow = saved.overflow;
        document.body.style.paddingRight = saved.paddingRight;
        saved = null;
      }
    };
  }, [active]);
};

export default useScrollLock;
